import application from 'application/application';

const controller = 'DefaultCopyClipboardController';

application.controller(controller, [
	'$scope',
	'$timeout',
	'$window',
	'notification',
	function($scope, $timeout, $window, notification) {
		let disableTimer, copiedTimer;

		$scope.copyDisabled = false; // estado do botão
		$scope.size = $scope.size && $scope.size > 0 ? $scope.size : '24';

		function doCopy(str) {
			if (
				$window.navigator &&
				$window.navigator.clipboard &&
				$window.navigator.clipboard.writeText
			) {
				return $window.navigator.clipboard.writeText(str);
			}

			return new Promise(function(resolve, reject) {
				try {
					var ta = document.createElement('textarea');

					ta.value = str;
					ta.setAttribute('readonly', '');
					ta.style.position = 'fixed';
					ta.style.opacity = '0';
					document.body.appendChild(ta);
					ta.select();
					var ok = document.execCommand('copy');

					document.body.removeChild(ta);
					ok ? resolve() : reject(new Error('execCommand falhou'));
				} catch (e) {
					reject(e);
				}
			});
		}

		$scope._copy = function() {
			if ($scope.copyDisabled) return; // já está desabilitado

			var value = $scope.text;

			if ((value === undefined || value === null) && $scope.getText) {
				var r = $scope.getText();

				value = r && typeof r === 'object' && 'text' in r ? r.text : r;
			}
			if (value === undefined || value === null) return;

			doCopy(String(value))
				.then(function() {
					$scope.$applyAsync(function() {
						$scope.copied = true;

						if (notification && notification.success) {
							notification.success('Copiado para a área de transferência.');
						}
						// badge por 1.5s
						copiedTimer = $timeout(function() {
							$scope.copied = false;
						}, 1500);

						// desabilita por 5s
						$scope.copyDisabled = true;
						disableTimer = $timeout(function() {
							$scope.copyDisabled = false;
						}, 5000);
					});
				})
				.catch(function(err) {
					$scope.$applyAsync(function() {
						if (notification && notification.danger)
							notification.danger('Não foi possível copiar.');
					});
					console.warn('[copy-clipboard] erro ao copiar:', err);
				});
		};

		// limpar timers ao destruir
		$scope.$on('$destroy', function() {
			if (disableTimer) $timeout.cancel(disableTimer);
			if (copiedTimer) $timeout.cancel(copiedTimer);
		});
	}
]);

export default controller;
